import React, { useEffect, useState } from 'react'
import { Sidebar } from '../components/Layout/Sidebar'
import Topbar from '../components/Layout/Topbar'
import { Toaster } from 'react-hot-toast'
import Partner from '../components/PartnerList/Partner'
import { supabase } from '../supabase.config'

const PartnerList = () => {
	const [activeTab, setActiveTab] = useState("Own")
	const [partnerlist, setPartnerList] = useState([])
  const [pageByTab, setPageByTab] = useState({})
  const rowsPerPage = 10
    const fetchPartnerList = async () => {
        try {
            // Map tabs to partner names stored in orders.forwarding_partner or package_details.partner
            const tabToPartner = {
                Own: 'GRC',
                Delivery: 'Delivery',
                Trackon: 'Trackon',
                Bluedart: 'Bluedart',
                DTDC: 'DTDC'
            }
            const partnerName = tabToPartner[activeTab] || 'DTDC'

            // First, filter by top-level forwarding_partner when available
            let { data, error } = await supabase
                .from('orders')
                .select('*')
                .eq('forwarding_partner', partnerName)
                .order('created_at', { ascending: false })

            // If no rows and partner stored in package_details (legacy), fallback by scanning
            if ((!data || data.length === 0) && !error) {
                const all = await supabase.from('orders').select('*').order('created_at', { ascending: false })
                if (!all.error) {
                    const rows = (all.data || []).filter(r => {
                        try {
                            const pkg = typeof r.package_details === 'object' ? r.package_details : JSON.parse(r.package_details || '{}')
                            return (pkg?.partner || '').toUpperCase() === partnerName.toUpperCase()
                        } catch { return false }
                    })
                    data = rows
                }
            }

            if (error) {
                console.error('Error fetching partners:', error)
                setPartnerList([])
                return
            }

            const mapped = (data || []).map(r => {
                const lrno = r.tracking_number || r.order_number
                const partner = r.forwarding_partner || (() => { try { const pkg = typeof r.package_details === 'object' ? r.package_details : JSON.parse(r.package_details || '{}'); return pkg.partner } catch { return '' } })()
                const forwardingNumber = r.forwarding_number || lrno
                return { id: r.id, lrno, partner, forwardingNumber }
            })

            setPartnerList(mapped)
        } catch (error) {
            console.error("Error fetching users:", error);
            setPartnerList([])
        }
    }
	useEffect(() => {
		fetchPartnerList();
	}, [activeTab])

  const currentPage = pageByTab[activeTab] || 1
  const totalPages = Math.max(1, Math.ceil(partnerlist.length / rowsPerPage))
  const safeCurrentPage = Math.min(currentPage, totalPages)
  const paginatedPartnerList = partnerlist.slice((safeCurrentPage - 1) * rowsPerPage, safeCurrentPage * rowsPerPage)

  useEffect(() => {
    if (currentPage !== safeCurrentPage) {
      setPageByTab((prev) => ({ ...prev, [activeTab]: safeCurrentPage }))
    }
  }, [activeTab, currentPage, safeCurrentPage])

  const handlePageChange = (page) => {
    setPageByTab((prev) => ({ ...prev, [activeTab]: page }))
  }
	return (
		<div className='crm-app-shell flex min-h-screen gap-3 p-3' >
			<Toaster />
			<Sidebar />
			<div className='crm-page-scroll flex flex-1 flex-col' >
				<Topbar />
				<div className='crm-page-body flex-1'>
					<Partner
            partnerlist={paginatedPartnerList}
            totalCount={partnerlist.length}
            currentPage={safeCurrentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
				</div>
			</div>
		</div>
	)
}

export default PartnerList
